import { CoinManagementHistoryPage } from './CoinManagementHistoryPage'
import { withCoinManagementHistoryPage } from './withCoinManagementHistoryPage'

const ConnectedCoinManagementHistoryPage = withCoinManagementHistoryPage(
  CoinManagementHistoryPage
)

export { ConnectedCoinManagementHistoryPage as CoinManagementHistoryPage }
